<script setup lang="ts">
import { useQuery } from "@tanstack/vue-query";
import api from "~/utils/auth/api";
const banners = ref<{ image: string; cta: string }[]>([]);
const router = useRouter();

const { data, isLoading } = useQuery<{ content: string }>({
	queryKey: ["promo-content"],
	queryFn: () =>
		api({
			url: "?host=content.betwayafrica.com&route=/content/synapse/bet-slip-banners/{brand}/&lang={locale}",
			type: "content",
			options: {
				method: "GET",
			},
		}),
	onSuccess: (data) => {
		try {
			banners.value = [];
			const bannersRaw = data.content
				.toString()
				.replace(/>[\r\n ]+</g, "><")
				.replace(/(<.*?>)|\s+/g, (_m, $1) => $1 || " ")
				.trim()
				.replace(/>\s+</g, "><")
				.match(/<banner>(.*?)<\/banner>/g);

			if (bannersRaw && bannersRaw.length) {
				bannersRaw.forEach((banner) => {
					const imageTags = banner.match(/<image>(.*?)<\/image>/g);
					const image = imageTags ? imageTags[0].replace("<image>", "").replace("</image>", "") : null;
					if (image) {
						const cta = JSON.parse(
							// @ts-ignore
							banner
								.match(/<cta>(.*?)<\/cta>/g)[0]
								.replace(/&quot;/g, '"')
								.replace("<cta>", "")
								.replace("</cta>", "") || "{}"
						);
						banners.value = [...banners.value, { image, cta: cta?.loggedOut?.Value }];
					}
				});
			}
		} catch (err) {}
	},
});

const handleCTA = (cta: string) => {
	router.push(cta);
};
</script>

<template>
	<NuxtErrorBoundary>
		<div v-if="data && !isLoading" class="flex flex-col gap-1 overflow-hidden rounded">
			<div
				v-for="(banner, idx) in banners"
				:key="`promo-banner-${idx}`"
				v-html="banner.image"
				:class="{ 'cursor-pointer': banner.cta }"
				@click="handleCTA(banner.cta)"
			/>
		</div>
	</NuxtErrorBoundary>
</template>
